import { RefObject, useEffect, useState } from 'react';

export interface UseAnimationsProps {
  componentRef: RefObject<HTMLDivElement | null>;
  onClose: () => void;
  isOpen: boolean;
}

export default function useAnimations({
  componentRef,
  onClose,
  isOpen,
}: UseAnimationsProps): boolean {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const { current } = componentRef;

    const transitionEnd = () => setIsActive(isOpen);

    const keyHandler = (e: KeyboardEvent) => e.key === 'Escape' && onClose();

    const clickHandler = (e: MouseEvent) => e.target === current && onClose();

    if (current) {
      current.addEventListener('transitionend', transitionEnd);
      current.addEventListener('mouseup', clickHandler);
      window.addEventListener('keyup', keyHandler);
    }

    if (isOpen) {
      window.setTimeout(() => {
        setIsActive(isOpen);
      }, 10);
    }

    return () => {
      if (current) {
        current.removeEventListener('transitionend', transitionEnd);
        current.removeEventListener('mouseup', clickHandler);
      }

      window.removeEventListener('keyup', keyHandler);
    };
  }, [isOpen, onClose, componentRef]);

  return isActive;
}
